$(".custom_collectin_list").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: true,
  autoplay: false,
  loop: true,
  prevArrow: `
    <button type="button" class="slick-prev">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="31.1906" y="30.807" width="30" height="30" rx="4" transform="rotate(179.267 31.1906 30.807)" fill="#202020"/>
        <path d="M13.3875 15.7778L16.8425 12.2333L15.9407 11.3698L11.005 16.4333L16.0686 21.3689L16.9479 20.4826L13.4035 17.0277L21.0122 16.9304L20.9962 15.6805L13.3875 15.7778Z" fill="white"/>
      </svg>
    </button>
  `,
  nextArrow: `
    <button type="button" class="slick-next">
      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.508789" y="0.759888" width="30" height="30" rx="4" fill="#202020"/>
        <path d="M18.1182 16.0155L14.6182 19.5155L15.5088 20.3905L20.5088 15.3905L15.5088 10.3905L14.6182 11.2655L18.1182 14.7655H10.5088V16.0155H18.1182Z" fill="white"/>
      </svg>
    </button>
  `,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        dots: false,
        arrows: true,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: true,
        dots: false,
        variableWidth: false,
      },
    },
  ],
});

document.addEventListener('DOMContentLoaded', function() {
  // Check if the popup has been shown in this session
  if (!sessionStorage.getItem('popupShown')) {
    // Set a delay of 2 seconds before showing the popup
    setTimeout(function() {
      var discountPopup = document.getElementById('discount-popup');
      discountPopup.style.display = 'flex'; // Show the popup

      // Close the popup when clicked outside of the modal content
      discountPopup.addEventListener('click', function(event) {
        if (event.target === discountPopup) {
          discountPopup.style.display = 'none';
        }
      });

      // Close the popup when the close button is clicked
      var closeButton = document.getElementById('close-popup');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          discountPopup.style.display = 'none';
        });
      }

      // Mark the popup as shown
      sessionStorage.setItem('popupShown', 'true');
    }, 2000); // 2000 milliseconds = 2 seconds
  }
});

setTimeout(function() {
  $(".product_custom_slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    loop: true,
    prevArrow: `
      <button type="button" class="slick-prev">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="31.1906" y="30.807" width="30" height="30" rx="4" transform="rotate(179.267 31.1906 30.807)" fill="#202020"/>
          <path d="M13.3875 15.7778L16.8425 12.2333L15.9407 11.3698L11.005 16.4333L16.0686 21.3689L16.9479 20.4826L13.4035 17.0277L21.0122 16.9304L20.9962 15.6805L13.3875 15.7778Z" fill="white"/>
        </svg>
      </button>
    `,
    nextArrow: `
      <button type="button" class="slick-next">
        <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.508789" y="0.759888" width="30" height="30" rx="4" fill="#202020"/>
          <path d="M18.1182 16.0155L14.6182 19.5155L15.5088 20.3905L20.5088 15.3905L15.5088 10.3905L14.6182 11.2655L18.1182 14.7655H10.5088V16.0155H18.1182Z" fill="white"/>
        </svg>
      </button>
    `,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          dots: false,
          arrows: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
          dots: false,
          variableWidth: false,
        },
      },
    ], 
  });
}, 2000);  // Adjust the time delay in milliseconds (1000 = 1 second)


